/*
 * kahwa-recharge-mount.js — Kahwa / Airwave, added 2026-09-01
 *
 * The Recharge unified widget (loaded by Recharge's ScriptTag, not the theme)
 * auto-injects into the first form[action*="cart/add"] it finds. On Airwave
 * that is usually the cart-drawer upsell form (a different product) or the
 * Shopify installments form, so the Subscribe & Save selector is missing from
 * the buy box on most loads and a stray widget lands on the upsell.
 *
 * This script waits for the widget API, tears down whatever auto-injected,
 * mounts one widget inside the main product form, and keeps the buy-box
 * price and the add-to-cart button price in step with the selected plan
 * (Recharge's own price sync only updates one of the two, inconsistently).
 */
(function () {
  if (!document.body.classList.contains('template-product')) return;

  var main = document.querySelector('form[data-product-form][action*="/cart/add"]');
  if (!main) return;
  var formId = main.getAttribute('id');
  if (!formId) return;
  var formSel = '#' + formId;

  var productId = null;
  try { productId = window.ShopifyAnalytics.meta.product.id; } catch (e) {}
  if (!productId) {
    var idInput = main.parentElement && main.parentElement.querySelector('input[name="product-id"]');
    productId = idInput && idInput.value;
  }
  if (!productId) return;

  var handle = (location.pathname.split('/products/')[1] || '').split('/')[0].split('?')[0];
  var productData = null;
  if (handle) {
    fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { productData = p; syncPrice(); })
      .catch(function () {});
  }

  function money(cents) {
    try { return window.theme.formatMoney(cents, window.theme.moneyFormat); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  function syncPrice() {
    if (!productData) return;
    var variantInput = main.querySelector('input[name="id"]');
    var planSelect = main.querySelector('.rc-widget select[name="selling_plan"]');
    var planInput = main.querySelector('input[name="selling_plan"]');
    if (!variantInput) return;
    var variant = null;
    for (var i = 0; i < productData.variants.length; i++) {
      if (String(productData.variants[i].id) === String(variantInput.value)) { variant = productData.variants[i]; break; }
    }
    if (!variant) return;
    var cents = variant.price;
    var planId = (planSelect && !planSelect.disabled) ? planSelect.value : (planInput ? planInput.value : '');
    if (planId && variant.selling_plan_allocations) {
      for (var j = 0; j < variant.selling_plan_allocations.length; j++) {
        if (String(variant.selling_plan_allocations[j].selling_plan_id) === String(planId)) {
          cents = variant.selling_plan_allocations[j].per_delivery_price || variant.selling_plan_allocations[j].price;
          break;
        }
      }
    }
    var text = money(cents);
    var targets = [
      document.querySelector('.product__price__wrap .price-item--regular'),
      main.querySelector('[data-product-price]')
    ];
    for (var k = 0; k < targets.length; k++) {
      if (targets[k] && targets[k].textContent.trim() !== text) targets[k].textContent = text;
    }
  }

  function widgetsIn(el) { return Array.prototype.slice.call(el.querySelectorAll('.rc-widget')); }
  function strayWidgets() {
    return Array.prototype.filter.call(document.querySelectorAll('.rc-widget'), function (w) { return !main.contains(w); });
  }
  // Strays are hidden, never removed: Recharge owns those nodes and their hidden inputs.
  function hideStrays() {
    strayWidgets().forEach(function (w) {
      var wrap = w.closest('.rc-container-wrapper') || w;
      if (wrap.style.display !== 'none') wrap.style.display = 'none';
    });
  }
  // Once the widget lives inside the form, Recharge's own <select name="selling_plan"> is the source of
  // truth (it is removed when One-time is chosen). The theme's empty hidden selling_plan input would be
  // serialized after it and win, silently turning subscriptions into one-time orders, so drop it.
  function dropThemePlanInput() {
    Array.prototype.forEach.call(main.querySelectorAll('input[type="hidden"][name="selling_plan"]'), function (inp) {
      if (!inp.closest('.rc-widget') && inp.parentNode) inp.parentNode.removeChild(inp);
    });
  }

  var attempts = 0;
  var lastAttempt = 0;
  function mount() {
    var rc = window.ReChargeWidget;
    if (!rc || typeof rc.createWidget !== 'function') return false;
    if (widgetsIn(main).length) { hideStrays(); dropThemePlanInput(); setTimeout(syncPrice, 50); return true; }
    if (attempts >= 2) return true;                                  // stop trying; leave whatever Recharge did
    if (lastAttempt && Date.now() - lastAttempt < 3000) return false; // give the last create time to land
    attempts++; lastAttempt = Date.now();
    try { if (typeof rc.destroyAllWidgets === 'function') rc.destroyAllWidgets(); } catch (e) {}
    try {
      rc.createWidget({ productId: Number(productId), injectionParent: formSel, injectionMethod: 'prepend' });
    } catch (e) {}
    return false;
  }

  var tries = 0;
  var timer = setInterval(function () {
    tries++;
    if (mount() || tries > 80) clearInterval(timer);   // ~20s ceiling
  }, 250);

  // Late auto-injections (cart-drawer upsells render asynchronously): keep the buy box authoritative.
  var settleChecks = 0;
  var settle = setInterval(function () {
    settleChecks++;
    if (widgetsIn(main).length) { hideStrays(); dropThemePlanInput(); }
    if (settleChecks > 30) clearInterval(settle);   // 30s
  }, 1000);

  // Plan or variant change → re-sync both prices (after Recharge and the theme have written theirs).
  main.addEventListener('change', function () { setTimeout(syncPrice, 60); setTimeout(syncPrice, 400); setTimeout(syncPrice, 1200); });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('variant-selects, [data-product-form], .product__block')) {
      setTimeout(syncPrice, 60); setTimeout(syncPrice, 400);
    }
  });
  document.addEventListener('theme:variant:change', function () { setTimeout(syncPrice, 60); setTimeout(syncPrice, 400); });
})();
